module.exports = __webpack_public_path__ + "static/web_capture dwell times.060e8ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/web_capture dwell times.png
// module id = 715
// module chunks = 154382131621592